import { ComponentPropsWithoutRef, ReactNode } from "react"

import styles from "./VideoControlButton.module.css"

export type VideoControlButtonProps =
  ComponentPropsWithoutRef<"button"> & {
    icon: ReactNode
  }

export const VideoControlButton = ({
  icon,
  ...props
}: VideoControlButtonProps) => {
  return (
    <button type="button" className={styles.videoControlButton} {...props}>
      {icon}
    </button>
  )
}
